const is_debug = location.host.indexOf('localhost') > -1
export const API_BASEURL = is_debug ? '/api' : '/aggregation'
export const COURSE_UPLOAD_BASEURL = is_debug ? '/api/videos' : '/aggregation/videos'
export const USER_UPLOAD_BASEURL = is_debug ? '/api/user_pic' : '/user_pic'
